export default __webpack_public_path__ + "static/media/store03.9638aabf.jpg";